import React, {useCallback} from 'react';
import { ButtonsGroup, PaperStyled } from '../../index.styles';
import { DocumentsWrapper, Field, IlumaTitle } from './index.styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Button from 'components/control/button/button';
import { EButtonType } from 'components/control/button/button.types';
import { EDocumentTypes } from 'types/entities/documents';
import DocumentComponent from '../documents/document-component';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SyncIcon from '@material-ui/icons/Sync';
import clsx from 'classnames';
import Skeleton from '@material-ui/lab/Skeleton';
import {IEKYCUserDocument} from "../../../../../../types/entities/users";
import {toast} from "react-toastify";
import useRevalidateKtpPost from "../approval/hooks/use-revalidate-ktp-post";
import {InfoWrapper} from "../approval/index.styles";
import FailedIcon from "../../../../../../components/icons/FailedIcon";

interface KtpProps {
  setNextPage: () => void;
  setPrevPage: () => void;
  handleSkip: () => void;
  data: any;
  refetch: () => void;
  kycId: string;
  userId: string
}

const ilumaKtpFields = [
  'is_name_match',
  'is_birthplace_match',
  'is_birthdate_match',
  'is_address_match',
];

const Ktp = ({
  setPrevPage,
  handleSkip,
  data,
  refetch,
  userId
}: KtpProps) => {
  const currentSelfie: IEKYCUserDocument = data?.ekycDocuments
    .filter((item: any) => item.type === EDocumentTypes.Selfie)
    .find((item: any) => item.imageData);

  const handleOnSuccessMutation = useCallback(() => {
    refetch();
  }, [refetch]);

  const [onRevalidateKtp, { isLoading: isKtpValidating }] = useRevalidateKtpPost({
    onSuccess: () => {
      handleOnSuccessMutation();
      toast.success('Requested to revalidate KTP successfully!');
    },
    onError: (e) => {
      toast.error(`Error: ${e}`, {
        pauseOnHover: true,
      });
    },
  });

  return (
    <React.Fragment>
      <DocumentsWrapper>
        <PaperStyled narrow>
          <IlumaTitle>
            KTP Validation
            <Tooltip
              title={
                'Sync data'
              }
            >
              <div>
                <IconButton
                  onClick={async () => {
                    await onRevalidateKtp({ id: userId });
                  }}
                >
                  <SyncIcon />
                </IconButton>
              </div>
            </Tooltip>
          </IlumaTitle>
          {isKtpValidating ? (
            <div>
              <Skeleton variant="text" width={150} style={{ marginTop: 15 }} />
              <Skeleton variant="text" width={150} style={{ marginTop: 15 }} />
              <Skeleton variant="text" width={150} style={{ marginTop: 15 }} />
              <Skeleton variant="text" width={150} style={{ marginTop: 15 }} />
              <Skeleton variant="text" width={150} style={{ marginTop: 15 }} />
            </div>
          ) : (
            data?.validations?.ktpValidation ? (
              (
                data.validations.ktpValidation.failure_reason ? (
                  <PaperStyled>
                    <InfoWrapper>
                      <FailedIcon />
                      <h4>KTP hasn't been verified: { data.validations.ktpValidation.failure_reason }</h4>
                      <h4>Please retry the validation by clicking on the above icon</h4>
                    </InfoWrapper>
                  </PaperStyled>
                ) : (
                  <PaperStyled>
                    <Field key={'id_card_number'}>
                      <h4 className="title">ID Card Number:</h4>
                      <span>{ data.validations.ktpValidation.id_card_number }</span>
                    </Field>
                    <Field key={'name'}>
                      <h4 className="title">Name:</h4>
                      <span>{ data.validations.ktpValidation.name }</span>
                    </Field>
                    <Field key={'birthdate'}>
                      <h4 className="title">Birth Date:</h4>
                      <span>{ data.validations.ktpValidation.birthdate }</span>
                    </Field>
                    <Field key={'phone'}>
                      <h4 className="title">Phone:</h4>
                      <span>{ data.validations.ktpValidation.phone }</span>
                    </Field>
                    <hr></hr>
                    <Field key={'status'}>
                      <h4 className="title">KTP check status:</h4>
                    </Field>
                    <Field>
                      {data.validations.ktpValidation.is_verified ? (
                        <span>
                          KTP is verified in Dukcapil's Database
                          <CheckIcon className={clsx(
                            'icon',
                            data.validations.ktpValidation.is_verified
                              ? 'approved'
                              : 'rejected',
                          )} />
                        </span>
                      ) : (
                        <span>
                          KTP is unverified in Dukcapil's Database
                          <CancelIcon className={clsx(
                            'icon',
                            data.validations.ktpValidation.is_verified
                              ? 'approved'
                              : 'rejected',
                          )} />
                        </span>
                      )}
                    </Field>
                  </PaperStyled>
                )
              )
            ) : (
              <PaperStyled>
                <InfoWrapper>
                  <FailedIcon />
                  <h4>{'Please click on the icon above to validate the KTP'}</h4>
                </InfoWrapper>
              </PaperStyled>
            )
          )}
        </PaperStyled>

        <PaperStyled narrow>
          <DocumentComponent
            kycData={currentSelfie}
            title={'Selfie'}
          />
        </PaperStyled>
      </DocumentsWrapper>
      <ButtonsGroup>
        <Button styleType={EButtonType.Outline} onClick={setPrevPage}>
          <NavigateBeforeIcon /> {'Back'}
        </Button>
        <Button styleType={EButtonType.Outline} onClick={handleSkip}>
          {'Next'} <NavigateNextIcon />
        </Button>
      </ButtonsGroup>
    </React.Fragment>
  );
};

export default Ktp;
